import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { getByQuery } from "../../api/API";
import LoadingSpinner from "../Generic/LoadingSpinner";

const StoriesSection = () => {
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchMedia = async () => {
      try {
        const query =
          "where[featuredStories][equals]=true&where[mimeType][like]=video/";
        const res = await getByQuery("/media", query);
        setVideos(res?.docs ?? []);
      } catch (err) {
        console.error("Error fetching media:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchMedia();
  }, []);

  return (
    <section className="py-5 bg-black text-white">
      <Container>
        {/* Heading */}
        <h2 className="wise-secondary-gradient fw-bold mb-2">WISE STORIES</h2>
        <p className="text-secondary mb-4">
          A growing collection of video highlights—interviews, reflections, and
          moments—capturing voices and experiences from across the WiSE
          ecosystem.
        </p>

        {/* Loading */}
        {loading && (
          <div className="d-flex justify-content-center py-5">
            <LoadingSpinner text="Loading stories..." />
          </div>
        )}

        {/* Videos */}
        {!loading && videos.length > 0 && (
          <Row className="g-4">
            {videos.map((video) => (
              <Col md={6} key={video.id}>
                <video
                  className="w-100 rounded"
                  controls
                  preload="metadata"
                  poster={video.thumbnail?.url}
                >
                  <source src={video.url} type={video.mimeType} />
                  Your browser does not support the video tag.
                </video>
              </Col>
            ))}
          </Row>
        )}

        {/* Empty state */}
        {!loading && videos.length === 0 && (
          <p className="text-secondary text-center mt-4">
            We are capturing inspiring journeys and bringing them here soon,<span style={{color: '#EA993e'}}> Stay tuned.</span>
          </p>
        )}
      </Container>
    </section>
  );
};

export default StoriesSection;
